import { render, staticRenderFns } from "./preOrderGoods.vue?vue&type=template&id=ddf118d2&scoped=true&"
import script from "./preOrderGoods.vue?vue&type=script&lang=js&"
export * from "./preOrderGoods.vue?vue&type=script&lang=js&"
import style0 from "./preOrderGoods.vue?vue&type=style&index=0&id=ddf118d2&lang=less&scoped=true&"
import style1 from "./preOrderGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf118d2",
  null
  
)

component.options.__file = "preOrderGoods.vue"
export default component.exports